import { useUserPhotosSuspense } from '@features/user-photos/queries'
import { Card, Group, Text } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/students/$studentNo/photo')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Photo',
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    const { data: photos } = useUserPhotosSuspense(studentNo, 'student')

    return (
        <div style={{ padding: 'var(--mantine-spacing-xs)' }}>
            <Group gap={'xs'}>
                <Card withBorder className={'w-fit'} orientation='horizontal'>
                    <Card.Section p={'xs'} withBorder>
                        <Text size='sm' c={'dimmed'} fw={500} mb={'xs'}>Entra / Teams</Text>
                        <img src={photos.entraPhoto || undefined} style={{ width: '10rem', height: '10rem', borderRadius: 'var(--mantine-radius-md)' }} />
                    </Card.Section>
                    <Card.Section p={'xs'}>
                        <Text size='sm' c={'dimmed'} fw={500} mb={'xs'}>CIS (180x180)</Text>
                        <img src={photos.cisPhoto || undefined} style={{ width: '10rem', height: '10rem', borderRadius: 'var(--mantine-radius-md)' }} />
                    </Card.Section>
                </Card>
            </Group>
        </div>
    )
}
